export default "__VITE_ASSET__CyF$xt74__"